export default __webpack_public_path__ + "static/media/reviewer-1.07859027.png";